import { BaseApi } from "@newview/infrastructure";

export abstract class SysDataBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'SysDataApi'
    }
}